// extracted by mini-css-extract-plugin
export default {"price-card":"PriceCard_price-card__FWcXE","badge-container":"PriceCard_badge-container__unb6B"};